import {
  COCKPIT_CONTEXT_QUICK_CASHFLOW,
  cockpitAssistApi,
} from './cockpitAssistApi';

export const quickCashflowAssistApi = async ({
  message,
  files,
  history,
  cohortColumnMapping,
  assistSession,
  cohortSheet,
  customerId,
  signal,
}) => {
  const data = await cockpitAssistApi({
    context: COCKPIT_CONTEXT_QUICK_CASHFLOW,
    message,
    files,
    history,
    cohortColumnMapping,
    assistSession,
    cohortSheet,
    customerId,
    signal,
  });
  return data?.quickCashflow || data;
};
